// src/admin/components/AdminNavbar.jsx
import { useTheme } from "../../context/ThemeContext";
import { getAdminStyles } from "../utils/adminStyles";
import { useNavigate } from "react-router-dom";
import { authService } from "../services/authService";
import ThemeToggle from "../../components/common/ThemeToggle";

export default function AdminNavbar({ onMenuToggle }) {
  const { isDark } = useTheme();
  const styles = getAdminStyles(isDark);
  const navigate = useNavigate();

  const handleLogout = () => {
    authService.logout();
    navigate("/admin/login");
  };

  return (
    <header className={`sticky top-0 z-30 px-4 sm:px-6 lg:px-8 py-4 lg:py-5 ${styles.navbar}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {/* Hamburger Menu */}
          <button
            onClick={onMenuToggle}
            className="lg:hidden p-2 rounded-lg hover:bg-white/10 transition-colors text-2xl"
            aria-label="Toggle sidebar"
          >
            ☰
          </button>

          <h2 className="text-xl sm:text-2xl font-semibold">Dashboard</h2>
        </div>

        <div className="flex items-center gap-3">
          <ThemeToggle />
          <button
            onClick={handleLogout}
            className="md:hidden px-4 py-2 rounded-xl border border-red-500/20 text-red-500 text-sm hover:bg-red-500/10 transition-colors"
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  );
}